// Detalhe técnico exibido na mensagem de erro (a API devolve "details"; erros de rede só "message")
export function getErrorDetail(error: any): string | undefined {
    return error?.details || error?.message;
}
